import {
    LIST_PAYMENT_METHODS_REQUEST,
    LIST_PAYMENT_METHODS_SUCCESS,
    LIST_PAYMENT_METHODS_FAILURE,
    LIST_PAYMENT_METHODS_RESET,
    BILLING_ACTION_REQUEST,
    BILLING_ACTION_SUCCESS,
    BILLING_ACTION_FAILURE,
    BILLING_ACTION_RESET,
} from './BillingTypes';

const initialPaymentMethodsState = {
    loading: false,
    paymentMethods: [],
    hasCustomer: false,
    error: null,
    loaded: false,
};

export const listPaymentMethodsReducer = (state = initialPaymentMethodsState, action) => {
    switch (action.type) {
        case LIST_PAYMENT_METHODS_RESET:
            return { ...initialPaymentMethodsState };
        case LIST_PAYMENT_METHODS_REQUEST:
            return { ...state, loading: true, error: null };
        case LIST_PAYMENT_METHODS_SUCCESS:
            return {
                loading: false,
                paymentMethods: action.payload?.paymentMethods || [],
                hasCustomer: !!action.payload?.hasCustomer,
                error: null,
                loaded: true,
            };
        case LIST_PAYMENT_METHODS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
                loaded: true,
            };
        default:
            return state;
    }
};

const initialActionState = {
    loading: false,
    action: null,
    data: null,
    error: null,
    success: false,
};

export const billingActionsReducer = (state = initialActionState, action) => {
    switch (action.type) {
        case BILLING_ACTION_RESET:
            return { ...initialActionState };
        case BILLING_ACTION_REQUEST:
            return {
                loading: true,
                action: action.payload?.action || null,
                data: null,
                error: null,
                success: false,
            };
        case BILLING_ACTION_SUCCESS:
            return {
                loading: false,
                action: action.payload?.action || null,
                data: action.payload?.data || null,
                error: null,
                success: true,
            };
        case BILLING_ACTION_FAILURE:
            return {
                loading: false,
                action: action.payload?.action || null,
                data: null,
                error: action.payload?.error || 'Unknown error',
                success: false,
            };
        default:
            return state;
    }
};
